
// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

﻿import API_BASE from "../config.js";
import { Dica, BotaoDica } from "../components/Dica";
import React, { useState, useEffect, useRef } from "react";
import { getLimitePlano, getPlanoAtual } from "../services/planLimits";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useTextosSegmento from "../i18n/useTextosSegmento";
import Layout from "../components/Layout";
import Modal from "../components/Modal";
import ModalOrcamentoCompleto from "../components/ModalOrcamentoCompleto";
import { authFetch } from "../services/authFetch";
import { fmt, caixaAlta } from "../services/formato";

const API = "" + API_BASE + "/api/v1/dados";

const STATUS_COR = {
  "Recepcao":"#6366f1","Diagnostico":"#f59e0b","Aguardando Aprovacao":"#f97316",
  "Em Servico":"#3b82f6","Aguardando Pecas":"#eab308","Concluido":"#22c55e","Entregue":"#94a3b8"
};

// Mesmas etapas/cores de frontend/src/pages/Agendamentos.js -- duplicado
// aqui (em vez de importado) pra nao criar dependencia cruzada entre
// paginas por causa so de um mapa de cores/labels.
const AG_ETAPA_INFO = {
  solicitacao:       { label: "Solicitação",       cor: "#6366f1" },
  pre_cadastro:      { label: "Pré-Cadastro",       cor: "#8b5cf6" },
  orcamento_enviado: { label: "Orçamento Enviado",  cor: "#f59e0b" },
  confirmado:        { label: "Confirmado",         cor: "#22c55e" },
  convertido_os:     { label: "Convertido em OS",   cor: "#3b82f6" },
  cancelado:         { label: "Cancelado",          cor: "#94a3b8" },
};

function getStorage(key, def) {
  try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(def)); } catch { return def; }
}
function setStorage(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
}

function BtnFechar({ onClick }) {
  return <button onClick={onClick} style={{background:"var(--bg4)",border:"none",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:20,lineHeight:1,padding:"4px 10px"}}>x</button>;
}

export default function Clientes() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // AUD-E: t() sensivel ao segmento. Usado SO nas chamadas de
  // vocabulario de veiculo; o resto da tela segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const tenantId = getTenantIdFromToken() || "1";
  const CLIENTES_KEY = "clientes_tenant_" + tenantId;

  const [clientes, setClientes]       = useState([]);
  // Pre-orcamento aberto sobre esta tela. Guarda so cliente e veiculo
  // escolhidos -- enquanto existir, nada foi gravado em lugar nenhum.
  const [modalPre, setModalPre]       = useState(null);
  // { texto, ok } -- o `ok` decide a cor. Guardar so o texto fazia
  // sucesso e falha sairem iguais, ambos em verde.
  const [avisoPre, setAvisoPre]       = useState(null);
  const [loading, setLoading]         = useState(true);
  const [busca, setBusca]             = useState("");
  const [modalNovo, setModalNovo]     = useState(false);
  // Cliente recem-salvo: enquanto existe, o modal de cadastro mostra as
  // acoes seguintes em vez do formulario. null = formulario normal.
  const [recemCadastrado, setRecemCadastrado] = useState(null);
  const [modalPerfil, setModalPerfil] = useState(null);
  const [modalVeiculo, setModalVeiculo] = useState(null);
  const [modalEditarC, setModalEditarC] = useState(null);
  const [form, setForm]               = useState({ nome:"", telefone:"", cpf:"", email:"", endereco:"" });
  const [formV, setFormV]             = useState({ placa:"", modelo:"", cor:"", ano:"", km:"" });
  // AUD-P (29/09/2026) -- trava de envio em curso. O botao de salvar nao
  // tinha nenhuma: dois cliques geravam dois POST e dois clientes (ids 68/69
  // do tenant 2, 23 ms de diferenca). Metade cliente da correcao; o servidor
  // tem a dele, para o caso de um navegador com bundle antigo.
  //
  // SAO DOIS, e por um motivo que o teste provou: a primeira versao usava so
  // o state e NAO travava nada (2 cliques = 2 POST, 5 cliques = 5 POST). Em
  // React o state lido dentro do handler e o do closure daquela renderizacao,
  // e o setState nao o atualiza no mesmo tick -- a rajada de cliques inteira
  // le "false". O ref muda na hora e e ele quem barra; o state existe apenas
  // para o botao mudar de aparencia.
  const salvandoRef = useRef(false);
  const [salvandoCliente, setSalvandoCliente] = useState(false);
  const [os, setOs]                   = useState([]);

  useEffect(() => {
    const CACHE_KEY = "clientes_cache_tenant_"+tenantId;
    // Carregar cache local imediatamente para nao mostrar vazio
    // Buscar sempre do backend - banco e fonte de verdade
    authFetch(API + "/clientes/" + tenantId, {})
      .then(r=>r.ok?r.json():[])
      .then(d=>{
        if(Array.isArray(d)){
          setClientes(d);
          localStorage.setItem(CACHE_KEY, JSON.stringify(d));
        }
      })
      .catch(()=>{
        // Apenas em caso de falha de rede usar cache
        try { const cache = JSON.parse(localStorage.getItem(CACHE_KEY)||"[]"); setClientes(cache); } catch{}
      })
      .finally(()=>setLoading(false));
  }, [tenantId]);

  useEffect(() => {
    // Correcao critica -- vazamento entre tenants: chave global antiga
    // "os_historico_v1" trazia OS de QUALQUER oficina aberta nesse navegador
    // para dentro do perfil do cliente. Agora le a lista isolada por tenant.
    const lista = getStorage("os_cache_tenant_" + tenantId, []);
    setOs(lista);
    // 31/08/2026 -- o Relatorio de Servicos (perfil do cliente) precisa
    // refletir o estado real do banco, nao so o cache local (que so e
    // atualizado quando a pessoa visita a tela de O.S.). Busca fresca da
    // API sempre que o perfil de um cliente e aberto -- se falhar, fica so
    // com o cache mesmo (comportamento antigo), sem quebrar a tela.
    if (modalPerfil) {
      authFetch(API + "/os/" + tenantId, {})
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (Array.isArray(d)) setOs(d); })
        .catch(() => {});
    }
  }, [modalPerfil, tenantId]);

  // Agendamentos do cliente aberto no perfil -- alimenta o Relatorio de
  // Servicos junto com o historico de O.S. (pedido do Abima de 31/08/2026:
  // cruzar cadastro + veiculo + servicos + OS num unico relatorio por
  // cliente, montado ao vivo a partir dos dados reais).
  const [agendamentosCliente, setAgendamentosCliente] = useState([]);
  useEffect(() => {
    if (!modalPerfil) { setAgendamentosCliente([]); return; }
    authFetch("/api/v1/dados/agendamentos/" + tenantId, {})
      .then(r => r.ok ? r.json() : [])
      .then(d => {
        if (!Array.isArray(d)) return;
        const doCliente = d.filter(a =>
          (a.cliente_id && a.cliente_id === modalPerfil.id) ||
          (a.telefone && a.telefone === modalPerfil.telefone)
        );
        setAgendamentosCliente(doCliente);
      })
      .catch(() => setAgendamentosCliente([]));
  }, [modalPerfil, tenantId]);

  const salvar = async (lista) => { setClientes(lista); };
  const apiSalvar = async (cliente) => {
    const r = await authFetch(API + "/clientes/" + tenantId, {
      method: "POST", headers: {"Content-Type":"application/json"},
      body: JSON.stringify(cliente)
    });
    return r.ok ? r.json() : null;
  };
  const apiExcluir = async (id) => {
    try { await authFetch(API + "/clientes/" + tenantId + "/" + id, { method: "DELETE" }); } catch {}
  };

  const iniciarServico = (cliente, veiculo) => {
    const preenchido = {
      cliente: cliente.nome,
      telefone: cliente.telefone,
      cpf: cliente.cpf || "",
      placa: veiculo ? veiculo.placa : "",
      veiculo: veiculo ? veiculo.modelo : "",
      km: veiculo ? (veiculo.km || "") : "",
      tecnico: "",
      obs: "",
      relatoCliente: "",
      servicosSolicitados: [],
      _fromCliente: true
    };
    localStorage.setItem("os_prefill", JSON.stringify(preenchido));
    navigate("/os");
  };

  const solicitarAgendamento = (cliente, veiculo) => {
    const prefill = {
      cliente_id: cliente.id,
      cliente_nome: cliente.nome,
      telefone: cliente.telefone,
      cpf: cliente.cpf || "",
      email: cliente.email || "",
      placa: veiculo ? veiculo.placa : "",
      veiculo: veiculo ? veiculo.modelo : "",
      km: veiculo ? (veiculo.km || "") : "",
      servico_solicitado: "",
      relato_cliente: "",
    };
    localStorage.setItem("agendamento_prefill", JSON.stringify(prefill));
    navigate("/agendamentos");
  };

  // Pre-orcamento: abre o documento AQUI, sobre a tela de Clientes. Nao
  // navega e NAO grava nada. O registro so passa a existir quando a pessoa
  // clicar em "Confirmar e Enviar Orcamento" -- ver enviarOrcamento abaixo.
  //
  // Antes, este botao criava um agendamento com status "solicitacao" antes
  // de qualquer confirmacao. Solicitacao e o cliente pedindo; pre-orcamento
  // e a oficina propondo. Alem do nome errado, enchia a tela de Agendamentos
  // de registros que depois alguem tinha que apagar a mao.
  const enviarPreOrcamento = (cliente, veiculo) => {
    setAvisoPre(null);
    setModalPre({ cliente, veiculo: veiculo || (cliente.veiculos || [])[0] || null });
  };

  // Grava o pre-orcamento ja ENVIADO, numa chamada so. O POST de
  // agendamentos aceita status, orcamento e total na criacao e registra o
  // historico com esse status -- entao nao existe estado intermediario: ou
  // nasce completo e enviado, ou nao nasce.
  const enviarOrcamento = async (dados) => {
    if (!modalPre) return;
    const c = modalPre.cliente || {};
    const v = modalPre.veiculo || {};
    const total = Number(dados && dados.total) || 0;
    const r = await authFetch(API + "/agendamentos/" + tenantId, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cliente_id: c.id || null,
        cliente_nome: c.nome || "",
        telefone: c.telefone || "",
        cpf: c.cpf || "",
        email: c.email || "",
        placa: v.placa || "",
        veiculo: v.modelo || "",
        km: v.km || "",
        servico_solicitado: "",
        relato_cliente: "",
        status: "orcamento_enviado",
        orcamento: { itens: (dados && dados.itens) || [], total,
                     modelo: (dados && dados.modelo) || "basico",
                     fotos: (dados && dados.fotos) || [] },
        orcamento_total: total,
        data_agendamento: null,
        criada: new Date().toLocaleString("pt-BR"),
      }),
    }).catch(() => null);

    if (!r || !r.ok) {
      // O modal fica aberto de proposito: os itens digitados continuam la
      // e a pessoa tenta de novo sem redigitar nada.
      setAvisoPre({ ok: false, texto: t("clientes.pre_falhou",
        "Nao foi possivel registrar o pre-orcamento. NADA foi gravado -- os itens continuam na tela, tente enviar de novo.") });
      return;
    }
    const res = await r.json().catch(() => ({}));
    setModalPre(null);
    setAvisoPre({ ok: true, texto:
      t("clientes.pre_enviado", "Pre-orcamento registrado como ") + (res.id || "") +
      t("clientes.pre_enviado_2", " e enviado ao cliente. Acompanhe em Agendamentos.") });
  };

  const fecharModalNovo = () => { setRecemCadastrado(null); setModalNovo(false); };

  const salvarCliente = async () => {
    if (!form.nome || !form.telefone) return;
    // AUD-P: segunda chamada durante a primeira nao faz nada. A barreira e o
    // ref, que muda sincronamente -- com state puro a rajada de cliques
    // passava inteira (provado no teste AUDP-F02/F03).
    if (salvandoRef.current) return;
    salvandoRef.current = true;
    setSalvandoCliente(true);
    try {
    const _plano = getPlanoAtual();
    const _limites = getLimitePlano(_plano);
    if (clientes.length >= _limites.max_clientes) {
      alert(t("clientes.limite_atingido", { max: _limites.max_clientes, plano: _plano.charAt(0).toUpperCase() + _plano.slice(1) }));
      return;
    }
    // Item 5 -- o veiculo agora entra junto no cadastro. Opcional: so vira
    // registro se placa E modelo vierem preenchidos, mesma regra do
    // salvarVeiculo(). Mesma forma {placa,modelo,cor,ano,km} do fluxo antigo,
    // entao o perfil, o agendamento e a OS leem sem precisar de mudanca.
    const veiculoInicial = (formV.placa && formV.modelo)
      ? [{ placa:formV.placa.toUpperCase(), modelo:formV.modelo, cor:formV.cor||"", ano:formV.ano||"", km:formV.km||"" }]
      : [];
    const novoCliente = { nome:form.nome, telefone:form.telefone, cpf:form.cpf, email:form.email, endereco:form.endereco, veiculos:veiculoInicial, criado: new Date().toLocaleDateString("pt-BR") };
    const res = await apiSalvar(novoCliente);
    let salvo = null;
    if (res && res.id) {
      salvo = { ...novoCliente, id: res.id };
      setClientes(l => [...l, salvo]);
    }
    setForm({ nome:"", telefone:"", cpf:"", email:"", endereco:"" });
    setFormV({ placa:"", modelo:"", cor:"", ano:"", km:"" });
    // Salvou: em vez de sumir com o modal, mostra o que fazer em seguida.
    // Se a gravacao falhou, fecha como antes -- sem inventar tela de erro
    // que nao existia.
    if (salvo) setRecemCadastrado(salvo); else setModalNovo(false);
    } finally {
      // finally: solta a trava mesmo se apiSalvar levantar. Sem isto um erro
      // de rede travaria o botao para sempre e o usuario nao conseguiria
      // tentar de novo -- seria trocar duplicidade por impossibilidade.
      salvandoRef.current = false;
      setSalvandoCliente(false);
    }
  };

  const editarCliente = async () => {
    if (!modalEditarC) return;
    // O cliente pode ter varios veiculos. Editamos o PRIMEIRO e mantemos os
    // demais intactos. Campos em branco nao apagam nada -- excluir veiculo
    // continua sendo pelo botao proprio do perfil.
    const veiculosAtuais = modalEditarC.veiculos || [];
    const temVeiculo = !!(formV.placa && formV.modelo);
    const veiculos = temVeiculo
      ? [{ placa: caixaAlta(formV.placa), modelo: formV.modelo, cor: formV.cor || "",
           ano: formV.ano || "", km: formV.km || "" }, ...veiculosAtuais.slice(1)]
      : veiculosAtuais;
    const atualizado = { ...modalEditarC, ...form, veiculos };
    await apiSalvar(atualizado);
    setClientes(l => l.map(c => c.id === modalEditarC.id ? atualizado : c));
    // O perfil aberto atras ficava com os dados antigos ate ser reaberto.
    setModalPerfil(p => (p && p.id === modalEditarC.id) ? atualizado : p);
    setModalEditarC(null);
  };

  const excluirCliente = async (id) => {
    if (!window.confirm(t("clientes.confirm_excluir"))) return;
    await apiExcluir(id);
    setClientes(l => l.filter(c => c.id !== id));
    setModalPerfil(null);
  };

  const salvarVeiculo = async () => {
    if (!formV.placa || !formV.modelo) return;
    const nova = clientes.map(c => c.id === modalVeiculo.id
      ? { ...c, veiculos: [...(c.veiculos||[]), { placa:formV.placa.toUpperCase(), modelo:formV.modelo, cor:formV.cor, ano:formV.ano, km:formV.km||"" }] }
      : c
    );
    await apiSalvar(nova.find(c => c.id === modalVeiculo.id));
    setClientes(nova);
    if (modalPerfil?.id === modalVeiculo.id) setModalPerfil(nova.find(c => c.id === modalVeiculo.id));
    setFormV({ placa:"", modelo:"", cor:"", ano:"", km:"" });
    setModalVeiculo(null);
  };

  const excluirVeiculo = async (clienteId, placa) => {
    const nova = clientes.map(c => c.id === clienteId ? { ...c, veiculos: c.veiculos.filter(v => v.placa !== placa) } : c);
    await apiSalvar(nova.find(c => c.id === clienteId));
    setClientes(nova);
    if (modalPerfil?.id === clienteId) setModalPerfil(nova.find(c => c.id === clienteId));
  };

  // ---------------------------------------------------------------------
  // Comparacao de nome tolerante a diferenca invisivel (14/09/2026).
  //
  // No banco o mesmo cliente aparece escrito de formas ligeiramente
  // diferentes: "JEFERSON" no cadastro e "JEFERSON " (com espaco) no campo
  // cliente da OS; na Maria, cedilha seguida de espaco. A comparacao exata
  // falhava por causa disso e o perfil mostrava 0 OS e R$ 0,00 mesmo com as
  // OS existindo e com os valores certos.
  //
  // norm() so serve para COMPARAR: tira acento, tira espaco das pontas e
  // passa para minusculo. Nao grava nada, nao corrige nome no banco e nao
  // muda o que aparece na tela -- o nome continua sendo exibido exatamente
  // como foi digitado.
  // ---------------------------------------------------------------------
  const norm = (s) => String(s == null ? "" : s)
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .trim().toLowerCase();

  const osDoCliente = (nome) => {
    const alvo = norm(nome);
    // Nome vazio nao casa com nada. Sem esta guarda, um cliente sem nome
    // recolheria todas as OS sem cliente gravado.
    if (!alvo) return [];
    return os.filter(o => norm(o.cliente) === alvo);
  };
  // Busca inteligente. O filtro anterior procurava so em nome, telefone e
  // CPF, comparando texto cru -- quem digitava "1145" nao achava
  // "(11) 4569-87", porque o parentese e o espaco ficam no meio, e quem
  // digitava "jose" nao achava "Jose". Agora:
  //   - nome, e-mail e endereco: sem acento e sem caixa (norm(), que ja
  //     existe neste arquivo desde a correcao do historico do cliente);
  //   - telefone e CPF/CNPJ: so os digitos dos dois lados, entao a mascara
  //     deixa de atrapalhar;
  //   - placa e modelo dos veiculos do cliente, que antes ficavam de fora.
  // Continua sendo filtro em memoria sobre a lista que a tela ja carregou
  // da API do proprio tenant: nenhuma rota nova, nenhuma consulta nova,
  // nenhum caminho por onde dado de outra oficina possa entrar.
  const soDigitos = (s) => String(s == null ? "" : s).replace(/\D+/g, "");
  const semSeparador = (s) => norm(s).replace(/[^a-z0-9]/g, "");

  const clienteCasa = (c, termo) => {
    const alvo = norm(termo);
    if (!alvo) return true;
    if (norm(c.nome).includes(alvo)) return true;
    if (norm(c.email).includes(alvo)) return true;
    if (norm(c.endereco).includes(alvo)) return true;

    const digitos = soDigitos(termo);
    if (digitos.length >= 3) {
      if (soDigitos(c.telefone).includes(digitos)) return true;
      if (soDigitos(c.cpf).includes(digitos)) return true;
    }

    const placa = semSeparador(termo);
    if (placa.length >= 3) {
      const achou = (c.veiculos || []).some(v =>
        semSeparador(v && v.placa).includes(placa)
      );
      if (achou) return true;
    }

    return (c.veiculos || []).some(v => norm(v && v.modelo).includes(alvo));
  };

  const filtrados = clientes.filter(c => clienteCasa(c, busca));

  return (
    <Layout>
      <div style={{display:"flex",flexDirection:"column",gap:20}}>

        {/* HEADER */}
        <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between"}}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{fontSize:22,fontWeight:700}}>{t("clientes.titulo")}</h1><BotaoDica id="clientes" /></div>
            <p style={{color:"var(--text2)",fontSize:13,marginTop:3}}>{t("clientes.subtitulo_count",{count:clientes.length})}</p>
          </div>
          <button className="btn-primary" onClick={()=>{setFormV({placa:"",modelo:"",cor:"",ano:"",km:""});setModalNovo(true);}} style={{fontSize:13,padding:"10px 20px"}}>{t("clientes.novo_cliente")}</button>
        </div>

        <Dica id="clientes" jaUsou={clientes.length > 0}
          texto={t("dicas.clientes", "Seus clientes e veículos reunidos em um só lugar. Cadastre uma vez e economize tempo na hora de abrir novas ordens de serviço.")} />

        {/* Resultado do envio do pre-orcamento -- logo abaixo do cabecalho,
            onde o olho ja esta. Antes ficava no fim da pagina, abaixo de
            todos os cards: a confirmacao chegava e ninguem via, e um envio
            que deu certo parecia nao ter acontecido.
            Fica na tela ate a pessoa fechar. Sumir sozinho seria pior -- e a
            unica confirmacao de que o documento foi registrado, e com que
            numero. */}
        {avisoPre && (
          <div style={{alignItems:"center",
                       background: avisoPre.ok ? "#22c55e15" : "#ef444415",
                       border: "1px solid " + (avisoPre.ok ? "#22c55e" : "#ef4444"),
                       borderRadius:10, color:"var(--text)", display:"flex", fontSize:13,
                       gap:12, justifyContent:"space-between", padding:"12px 16px"}}>
            <span style={{alignItems:"center",display:"flex",gap:10}}>
              <span style={{color: avisoPre.ok ? "#22c55e" : "#ef4444", fontSize:11,
                            fontWeight:700, letterSpacing:"0.08em", textTransform:"uppercase",
                            whiteSpace:"nowrap"}}>
                {avisoPre.ok ? t("clientes.pre_ok", "Enviado") : t("clientes.pre_erro", "Nao gravou")}
              </span>
              <span>{avisoPre.texto}</span>
            </span>
            <BtnFechar onClick={()=>setAvisoPre(null)} />
          </div>
        )}

        {/* BUSCA -- o estado `busca` ja existia neste arquivo desde sempre,
            mas nenhum campo o alimentava: setBusca() nunca era chamado, o
            filtro recebia "" e a tela nunca filtrava. Este e o campo que
            faltava. Nao carrega nada novo: filtra o que ja esta em memoria. */}
        <div style={{position:"relative"}}>
          <span aria-hidden="true" style={{color:"var(--text3)",fontSize:14,left:14,pointerEvents:"none",position:"absolute",top:"50%",transform:"translateY(-50%)"}}>&#9906;</span>
          <input
            id="clientes-busca"
            type="search"
            value={busca}
            onChange={e=>setBusca(e.target.value)}
            placeholder={t("clientes.busca_placeholder","Buscar por nome, telefone, CPF, e-mail ou placa...")}
            aria-label={t("clientes.busca_placeholder","Buscar por nome, telefone, CPF, e-mail ou placa...")}
            style={{background:"var(--bg2)",border:"1px solid var(--border)",borderRadius:10,color:"var(--text)",fontSize:14,outline:"none",padding:"11px 14px 11px 38px",width:"100%"}}
          />
          {busca && (
            <span style={{color:"var(--text3)",fontSize:12,marginTop:6,display:"block"}}>
              {filtrados.length} {t("clientes.busca_de","de")} {clientes.length} {t("clientes.busca_clientes","clientes")}
            </span>
          )}
        </div>



        {/* LISTA */}
        {loading ? (
          <div style={{color:"var(--text3)",fontSize:14,padding:"40px 0",textAlign:"center"}}>
            {t("common.carregando")}
          </div>
        ) : filtrados.length === 0 ? (
          <div style={{color:"var(--text3)",fontSize:14,padding:"40px 0",textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>👤</div>
            {busca ? t("clientes.nenhum_encontrado") : t("clientes.nenhum_cadastrado")}
          </div>
        ) : (
          <div style={{display:"grid",gap:12,gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))"}}>
            {filtrados.map(c => {
              const osC = osDoCliente(c.nome);
              const total = osC.reduce((a,o)=>a+(o.total||0),0);
              return (
                <div key={c.id} onClick={()=>setModalPerfil(c)}
                  className="card" style={{cursor:"pointer",transition:"transform 0.15s"}}
                  onMouseOver={e=>e.currentTarget.style.transform="translateY(-2px)"}
                  onMouseOut={e=>e.currentTarget.style.transform="none"}>
                  <div style={{alignItems:"center",display:"flex",gap:12,marginBottom:12}}>
                    <div style={{alignItems:"center",background:"var(--accent)22",borderRadius:99,color:"var(--accent)",display:"flex",fontSize:18,fontWeight:700,height:44,justifyContent:"center",width:44}}>
                      {c.nome.charAt(0).toUpperCase()}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:14,fontWeight:700,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.nome}</div>
                      <div style={{color:"var(--text2)",fontSize:12}}>{c.telefone}</div>
                    </div>
                  </div>
                  <div style={{display:"flex",gap:16}}>
                    <div style={{textAlign:"center"}}>
                      <div style={{color:"var(--accent)",fontSize:18,fontWeight:800}}>{(c.veiculos||[]).length}</div>
                      <div style={{color:"var(--text3)",fontSize:10}}>{tSeg("clientes.veiculos")}</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{color:"#3b82f6",fontSize:18,fontWeight:800}}>{osC.length}</div>
                      <div style={{color:"var(--text3)",fontSize:10}}>OS</div>
                    </div>
                    <div style={{textAlign:"center"}}>
                      <div style={{color:"#22c55e",fontSize:14,fontWeight:800}}>R$ {total.toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                      <div style={{color:"var(--text3)",fontSize:10}}>{t("clientes.total_gasto")}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* MODAL NOVO CLIENTE */}
        {modalNovo && (
          <Modal onClose={fecharModalNovo} largura={500}>
            <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h2 style={{fontSize:18,fontWeight:700}}>{recemCadastrado ? t("clientes.cadastrado_titulo","Cliente cadastrado") : t("clientes.modal_novo_titulo")}</h2>
              <BtnFechar onClick={fecharModalNovo} />
            </div>

            {/* Depois de salvar, o modal nao some: oferece o passo seguinte.
                "So salvar" fecha, entao nada virou obrigatorio. */}
            {recemCadastrado ? (
              <div style={{display:"flex",flexDirection:"column",gap:14}}>
                <div style={{alignItems:"center",background:"rgba(22,163,74,0.10)",border:"1px solid rgba(34,197,94,0.4)",borderLeft:"3px solid #22c55e",borderRadius:11,display:"flex",flexWrap:"wrap",gap:13,padding:"13px 15px"}}>
                  <span aria-hidden="true" style={{fontSize:18,lineHeight:1}}>&#10003;</span>
                  <span style={{flex:1,minWidth:170}}>
                    <span style={{display:"block",fontSize:13.5,fontWeight:700}}>{recemCadastrado.nome}</span>
                    <span style={{color:"var(--text2)",display:"block",fontSize:12}}>
                      {(recemCadastrado.veiculos||[])[0]
                        ? ((recemCadastrado.veiculos[0].modelo||"") + " \u00b7 " + (recemCadastrado.veiculos[0].placa||""))
                        : tSeg("clientes.sem_veiculo_ainda","sem veiculo cadastrado")}
                    </span>
                  </span>
                </div>
                <div style={{color:"var(--text2)",fontSize:13}}>{t("clientes.e_agora","E agora?")}</div>
                <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                  <button onClick={()=>enviarPreOrcamento(recemCadastrado,(recemCadastrado.veiculos||[])[0])}
                    style={{background:"#b45309",border:"none",borderRadius:9,color:"#fff",cursor:"pointer",fontSize:12.5,fontWeight:700,padding:"9px 15px"}}>{t("clientes.pre_orcamento","Pre-Orcamento")}</button>
                  <button onClick={()=>solicitarAgendamento(recemCadastrado,(recemCadastrado.veiculos||[])[0])}
                    style={{background:"#6366f1",border:"none",borderRadius:9,color:"#fff",cursor:"pointer",fontSize:12.5,fontWeight:700,padding:"9px 15px"}}>{t("clientes.agendar")}</button>
                  <button onClick={fecharModalNovo}
                    style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:9,color:"var(--text2)",cursor:"pointer",fontSize:12.5,fontWeight:700,padding:"9px 15px"}}>{t("clientes.so_salvar","So salvar")}</button>
                </div>
              </div>
            ) : (
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["nome",t("clientes.nome_completo")],["telefone",t("clientes.telefone")],["cpf",t("clientes.cpf_cnpj")],["email",t("clientes.email")],["endereco",t("clientes.endereco")]].map(([campo,label])=>(
                <div key={campo}>
                  <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                  <input value={form[campo]} onChange={e=>setForm(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                    inputMode={campo==="telefone"||campo==="cpf"?"numeric":"text"} style={{width:"100%"}} />
                </div>
              ))}
              {/* Item 5 -- veiculo no mesmo passo do cadastro. Opcional:
                  sem placa+modelo o cliente e criado sem veiculo, e o botao
                  "Adicionar" do perfil continua servindo para os proximos. */}
              <div style={{borderTop:"1px solid var(--border)",marginTop:6,paddingTop:14}}>
                <div style={{alignItems:"baseline",display:"flex",gap:8,marginBottom:10}}>
                  <span style={{fontSize:12,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase"}}>{tSeg("clientes.veiculo","Veiculo")}</span>
                  <span style={{color:"var(--text3)",fontSize:11}}>{t("clientes.veiculo_opcional","opcional")}</span>
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))"}}>
                  {[["placa",t("clientes.placa")],["modelo",t("clientes.modelo")],["cor",t("clientes.cor")],["ano",t("clientes.ano")],["km",t("clientes.km_atual")]].map(([campo,label])=>(
                    <div key={campo}>
                      <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                      <input value={formV[campo]||""} onChange={e=>setFormV(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                        inputMode={campo==="ano"||campo==="km"?"numeric":"text"} style={{width:"100%"}} />
                    </div>
                  ))}
                </div>
                <div style={{color:"var(--text3)",fontSize:11,marginTop:8}}>
                  {tSeg("clientes.veiculo_hint","Preencha placa e modelo para ja cadastrar o veiculo junto.")}
                </div>
              </div>
              <div style={{display:"flex",gap:10,marginTop:8}}>
                <button className="btn-ghost" onClick={fecharModalNovo} style={{flex:1}}>{t("common.cancelar")}</button>
                <button className="btn-primary" onClick={salvarCliente} disabled={salvandoCliente} style={{flex:1,opacity:salvandoCliente?0.6:1,cursor:salvandoCliente?"not-allowed":"pointer"}}>{salvandoCliente?t("common.salvando"):t("clientes.salvar_cliente")}</button>
              </div>
            </div>
            )}
          </Modal>
        )}

        {/* MODAL EDITAR CLIENTE */}
        {modalEditarC && (
          <Modal onClose={()=>setModalEditarC(null)} largura={500}>
            <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h2 style={{fontSize:18,fontWeight:700}}>{t("clientes.modal_editar_titulo")}</h2>
              <BtnFechar onClick={()=>setModalEditarC(null)} />
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["nome",t("clientes.nome_completo")],["telefone",t("clientes.telefone")],["cpf",t("clientes.cpf_cnpj")],["email",t("clientes.email")],["endereco",t("clientes.endereco")]].map(([campo,label])=>(
                <div key={campo}>
                  <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                  <input value={form[campo]||""} onChange={e=>setForm(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                    inputMode={campo==="telefone"||campo==="cpf"?"numeric":"text"} style={{width:"100%"}} />
                </div>
              ))}
              {/* Reabrir por completo: o veiculo tambem entra na edicao. */}
              <div style={{borderTop:"1px solid var(--border)",marginTop:6,paddingTop:14}}>
                <div style={{alignItems:"baseline",display:"flex",gap:8,marginBottom:10}}>
                  <span style={{fontSize:12,fontWeight:700,letterSpacing:"0.06em",textTransform:"uppercase"}}>{tSeg("clientes.veiculo","Veiculo")}</span>
                  {(modalEditarC.veiculos||[]).length>1 && (
                    <span style={{color:"var(--text3)",fontSize:11}}>
                      {t("clientes.outros_veiculos","+{{n}} outro(s) preservado(s)").replace("{{n}}",(modalEditarC.veiculos||[]).length-1)}
                    </span>
                  )}
                </div>
                <div style={{display:"grid",gap:10,gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))"}}>
                  {[["placa",t("clientes.placa")],["modelo",t("clientes.modelo")],["cor",t("clientes.cor")],["ano",t("clientes.ano")],["km",t("clientes.km_atual")]].map(([campo,label])=>(
                    <div key={campo}>
                      <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                      <input value={formV[campo]||""} onChange={e=>setFormV(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                        inputMode={campo==="ano"||campo==="km"?"numeric":"text"} style={{width:"100%"}} />
                    </div>
                  ))}
                </div>
                <div style={{color:"var(--text3)",fontSize:11,marginTop:8}}>
                  {tSeg("clientes.veiculo_edit_hint","Deixar em branco nao remove o veiculo. Para excluir, use o perfil do cliente.")}
                </div>
              </div>
              <div style={{display:"flex",gap:10,marginTop:8}}>
                <button className="btn-ghost" onClick={()=>setModalEditarC(null)} style={{flex:1}}>{t("common.cancelar")}</button>
                <button className="btn-primary" onClick={editarCliente} style={{flex:1}}>{t("common.salvar")}</button>
              </div>
            </div>
          </Modal>
        )}

        {/* MODAL PERFIL */}
        {modalPerfil && (
          <Modal onClose={()=>setModalPerfil(null)} largura={700}>
            <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <div style={{alignItems:"center",display:"flex",gap:12}}>
                <div style={{alignItems:"center",background:"var(--accent)22",borderRadius:99,color:"var(--accent)",display:"flex",fontSize:22,fontWeight:700,height:52,justifyContent:"center",width:52}}>
                  {modalPerfil.nome.charAt(0).toUpperCase()}
                </div>
                <div>
                  <div style={{fontSize:18,fontWeight:800}}>{modalPerfil.nome}</div>
                  <div style={{color:"var(--text2)",fontSize:12}}>{modalPerfil.telefone}{modalPerfil.email?" · "+modalPerfil.email:""}</div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>{setForm({nome:modalPerfil.nome,telefone:modalPerfil.telefone,cpf:modalPerfil.cpf||"",email:modalPerfil.email||"",endereco:modalPerfil.endereco||""});const v0=(modalPerfil.veiculos||[])[0]||{};setFormV({placa:v0.placa||"",modelo:v0.modelo||"",cor:v0.cor||"",ano:v0.ano||"",km:v0.km||""});setModalEditarC(modalPerfil);}}
                  style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:12,padding:"6px 12px"}}>{t("common.editar")}</button>
                <button onClick={()=>iniciarServico(modalPerfil, (modalPerfil.veiculos||[])[0])}
                style={{background:"#22c55e",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"6px 14px"}}>{t("clientes.iniciar_os")}</button>
                <button onClick={()=>solicitarAgendamento(modalPerfil, (modalPerfil.veiculos||[])[0])}
                style={{background:"#6366f1",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"6px 14px"}}>{t("clientes.agendar")}</button>
                <button onClick={()=>enviarPreOrcamento(modalPerfil, (modalPerfil.veiculos||[])[0])}
                title={t("clientes.tooltip_pre_orcamento","Abre um pre-orcamento ja vinculado a este cliente")}
                style={{background:"#b45309",border:"none",borderRadius:8,boxShadow:"0 0 0 1px rgba(245,158,11,.45), 0 8px 20px -8px rgba(180,83,9,1)",color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"6px 14px"}}>{t("clientes.pre_orcamento","Pre-Orcamento")}</button>
              <button onClick={()=>excluirCliente(modalPerfil.id)} style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:8,color:"#ef4444",cursor:"pointer",fontSize:12,padding:"6px 12px"}}>{t("common.excluir")}</button>
                <BtnFechar onClick={()=>setModalPerfil(null)} />
              </div>
            </div>

            {/* Info do cliente */}
            <div style={{background:"var(--bg3)",borderRadius:10,display:"grid",gap:12,gridTemplateColumns:"repeat(3,1fr)",marginBottom:20,padding:16}}>
              {[[t("clientes.cpf_cnpj"),modalPerfil.cpf||"—"],[t("clientes.email"),modalPerfil.email||"—"],[t("clientes.endereco"),modalPerfil.endereco||"—"],[t("clientes.cliente_desde"),modalPerfil.criado||"—"],[tSeg("clientes.veiculos"),(modalPerfil.veiculos||[]).length],[t("clientes.total_gasto"),"R$ "+osDoCliente(modalPerfil.nome).reduce((a,o)=>a+(o.total||0),0).toLocaleString("pt-BR",{minimumFractionDigits:2})]].map(([l,v])=>(
                <div key={l}><div style={{color:"var(--text3)",fontSize:10,fontWeight:700,marginBottom:2,textTransform:"uppercase"}}>{l}</div><div style={{fontSize:13,fontWeight:600}}>{v}</div></div>
              ))}
            </div>

            {/* Veiculos */}
            <div style={{marginBottom:20}}>
              <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:10}}>
                <div style={{fontSize:13,fontWeight:700}}>{tSeg("clientes.veiculos")}</div>
                <button onClick={()=>{setFormV({placa:"",modelo:"",cor:"",ano:"",km:""});setModalVeiculo(modalPerfil);}} style={{background:"var(--accent)",border:"none",borderRadius:6,color:"#fff",cursor:"pointer",fontSize:11,padding:"4px 10px"}}>{t("clientes.adicionar")}</button>
              </div>
              {(modalPerfil.veiculos||[]).length === 0 ? (
                <div style={{color:"var(--text3)",fontSize:12,padding:"12px 0"}}>{tSeg("clientes.nenhum_veiculo")}</div>
              ) : (
                <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
                  {(modalPerfil.veiculos||[]).map((v,i)=>(
                    <div key={i} style={{alignItems:"center",background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,display:"flex",gap:10,justifyContent:"space-between",padding:"8px 12px"}}>
                      <div>
                        <div style={{fontFamily:"monospace",fontSize:12,fontWeight:700}}>{v.placa}</div>
                        <div style={{color:"var(--text2)",fontSize:11}}>{v.modelo}{v.ano?" ("+v.ano+")":""}{v.cor?" · "+v.cor:""}{v.km?" · "+v.km+"km":""}</div>
                      </div>
                      <button onClick={()=>iniciarServico(modalPerfil,v)} title={tSeg("clientes.tooltip_iniciar_os")}
                        style={{background:"#22c55e22",border:"1px solid #22c55e",borderRadius:6,color:"#22c55e",cursor:"pointer",fontSize:10,fontWeight:700,padding:"3px 8px",marginRight:4}}>OS</button>
                      <button onClick={()=>solicitarAgendamento(modalPerfil,v)} title={t("clientes.tooltip_agendar")}
                        style={{background:"#6366f122",border:"1px solid #6366f1",borderRadius:6,color:"#6366f1",cursor:"pointer",fontSize:10,fontWeight:700,padding:"3px 8px",marginRight:4}}>AG</button>
                      <button onClick={()=>enviarPreOrcamento(modalPerfil,v)} title={t("clientes.tooltip_pre_orcamento","Abre um pre-orcamento ja vinculado a este cliente")}
                        style={{background:"#b4530922",border:"1px solid #b45309",borderRadius:6,color:"#d97706",cursor:"pointer",fontSize:10,fontWeight:700,padding:"3px 8px",marginRight:4}}>PRE</button>
                      <button onClick={()=>excluirVeiculo(modalPerfil.id,v.placa)} style={{background:"none",border:"none",color:"#ef4444",cursor:"pointer",fontSize:14}}>×</button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Relatorio de Servicos -- cruza agendamentos + O.S. do cliente,
                montado ao vivo a partir dos dados reais (nao e uma copia
                salva separada, entao nunca fica desatualizado nem conflita
                com o resto do sistema). Pedido do Abima de 31/08/2026. */}
            <div style={{marginBottom:20}}>
              <div style={{fontSize:14,fontWeight:800,marginBottom:2}}>📋 Relatório de Serviços</div>
              <div style={{color:"var(--text3)",fontSize:11.5,marginBottom:14}}>Cadastro, veículos, agendamentos e ordens de serviço deste cliente, atualizado automaticamente.</div>

              <div style={{fontSize:12,fontWeight:700,marginBottom:8,color:"var(--text2)"}}>Agendamentos ({agendamentosCliente.length})</div>
              {agendamentosCliente.length === 0 ? (
                <div style={{color:"var(--text3)",fontSize:12,padding:"6px 0 16px"}}>Nenhum agendamento para este cliente.</div>
              ) : (
                <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:16,maxHeight:160,overflowY:"auto"}}>
                  {agendamentosCliente.map((a,i)=>{
                    const info = AG_ETAPA_INFO[a.status] || { label: a.status, cor: "#6366f1" };
                    let dataFmt = "—";
                    try { dataFmt = new Date(a.updated_at || a.created_at).toLocaleString("pt-BR"); } catch {}
                    return (
                      <div key={i} style={{alignItems:"center",background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,display:"flex",gap:12,justifyContent:"space-between",padding:"8px 12px"}}>
                        <div>
                          <div style={{color:"var(--accent2)",fontFamily:"monospace",fontSize:11,fontWeight:700}}>{a.id}</div>
                          <div style={{color:"var(--text3)",fontSize:10.5,marginTop:1}}>Atualizado em {dataFmt}</div>
                        </div>
                        <span style={{background:info.cor+"22",borderRadius:6,color:info.cor,fontSize:10.5,fontWeight:700,padding:"2px 8px",whiteSpace:"nowrap"}}>{info.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}

              <div style={{fontSize:12,fontWeight:700,marginBottom:8,color:"var(--text2)"}}>{t("clientes.historico_os")} ({osDoCliente(modalPerfil.nome).length})</div>
              {osDoCliente(modalPerfil.nome).length === 0 ? (
                <div style={{color:"var(--text3)",fontSize:12,padding:"12px 0"}}>{t("clientes.nenhuma_os")}</div>
              ) : (
                <div style={{display:"flex",flexDirection:"column",gap:8,maxHeight:200,overflowY:"auto"}}>
                  {osDoCliente(modalPerfil.nome).map((o,i)=>(
                    <div key={i} style={{alignItems:"center",background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,display:"flex",gap:12,justifyContent:"space-between",padding:"10px 14px"}}>
                      <div>
                        <div style={{color:"var(--accent)",fontFamily:"monospace",fontSize:12,fontWeight:700}}>{o.id}</div>
                        <div style={{color:"var(--text2)",fontSize:11,marginTop:2}}>{o.veiculo} · {o.criada}</div>
                        {Array.isArray(o.servicos) && o.servicos.length > 0 && (
                          <div style={{color:"var(--text3)",fontSize:10.5,marginTop:3}}>{o.servicos.map(s=>s.nome).join(", ")}</div>
                        )}
                      </div>
                      <span style={{background:(STATUS_COR[o.status]||"#6366f1")+"22",borderRadius:6,color:STATUS_COR[o.status]||"#6366f1",fontSize:11,fontWeight:600,padding:"2px 8px",whiteSpace:"nowrap"}}>{o.status}</span>
                      <div style={{color:"#22c55e",fontWeight:700}}>R$ {(o.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Modal>
        )}

        {/* PRE-ORCAMENTO -- montado aqui, gravado so no envio */}
        {modalPre && (
          <ModalOrcamentoCompleto
            titulo={(modalPre.cliente && modalPre.cliente.nome) || t("clientes.pre_orcamento","Pre-Orcamento")}
            tipoDocumento="pre_orcamento"
            cliente={{
              nome: (modalPre.cliente && modalPre.cliente.nome) || "",
              telefone: (modalPre.cliente && modalPre.cliente.telefone) || "",
              placa: (modalPre.veiculo && modalPre.veiculo.placa) || "",
              veiculo: (modalPre.veiculo && modalPre.veiculo.modelo) || "",
              servico: "",
            }}
            /* Ainda nao existe numero: o registro so nasce no envio. O
               documento mostra o cliente no lugar da referencia, e o numero
               aparece na confirmacao depois de gravado. */
            osId={(modalPre.cliente && modalPre.cliente.nome) || ""}
            tenantId={tenantId}
            modeloInicial="basico"
            featuresLiberadas={[]}
            onFechar={()=>setModalPre(null)}
            onConfirmar={enviarOrcamento}
          />
        )}

        {/* MODAL NOVO VEICULO */}
        {modalVeiculo && (
          <Modal onClose={()=>setModalVeiculo(null)} largura={420}>
            <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20}}>
              <h2 style={{fontSize:16,fontWeight:700}}>{tSeg("clientes.modal_veiculo_titulo")}</h2>
              <BtnFechar onClick={()=>setModalVeiculo(null)} />
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:12}}>
              {[["placa",t("clientes.placa")],["modelo",t("clientes.modelo")],["cor",t("clientes.cor")],["ano",t("clientes.ano")],["km",t("clientes.km_atual")]].map(([campo,label])=>(
                <div key={campo}>
                  <label style={{color:"var(--text2)",display:"block",fontSize:11,fontWeight:600,marginBottom:4,textTransform:"uppercase"}}>{label}</label>
                  <input value={formV[campo]} onChange={e=>setFormV(f=>({...f,[campo]:fmt(campo,e.target.value)}))}
                    inputMode={campo==="ano"||campo==="km"?"numeric":"text"} style={{width:"100%"}} />
                </div>
              ))}
              <div style={{display:"flex",gap:10,marginTop:8}}>
                <button className="btn-ghost" onClick={()=>setModalVeiculo(null)} style={{flex:1}}>{t("common.cancelar")}</button>
                <button className="btn-primary" onClick={salvarVeiculo} style={{flex:1}}>{tSeg("clientes.salvar_veiculo")}</button>
              </div>
            </div>
          </Modal>
        )}

      </div>
    </Layout>
  );
}







